import { connect } from "react-redux";
import OvSubbar from "./OvSubbar";
import { setOverviewTab } from "./actions/route";

const mapStateToProps = (state, ownProps) => {
  return {
    tabIndex: state.route.overviewTabIndex,
    labels: state.route.overviewTabLabels
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    persistTab: index => {
      dispatch(setOverviewTab(index));
    }
  };
};

const OvSubbarContainer = connect(mapStateToProps, mapDispatchToProps)(
  OvSubbar
);

export default OvSubbarContainer;



// WEBPACK FOOTER //
// ./src/OvSubbarContainer.js